import { render, staticRenderFns } from "./header.vue?vue&type=template&id=b6166118&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=b6166118&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=b6166118&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6166118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6166118')) {
      api.createRecord('b6166118', component.options)
    } else {
      api.reload('b6166118', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=b6166118&scoped=true", function () {
      api.rerender('b6166118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/components/header.vue"
export default component.exports